export default "__VITE_ASSET__BteTzmVB__"